import React from 'react';

const Svg = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M10.002 18.1816C11.006 18.1817 11.8202 18.5888 11.8203 19.0908C11.8203 19.5929 11.006 20 10.002 20C8.9978 20 8.18359 19.5929 8.18359 19.0908C8.18369 18.5888 8.99786 18.1816 10.002 18.1816ZM10.002 0C14.5204 0.000164157 18.1835 3.66313 18.1836 8.18164V13.6367L19.8203 15.8184C20.2693 16.4176 19.8416 17.2723 19.0928 17.2725H0.911133C0.162023 17.2725 -0.265821 16.4177 0.183594 15.8184L1.82031 13.6367V8.18164C1.82041 3.66303 5.48332 0 10.002 0ZM10.002 1.81836C6.48747 1.81836 3.63779 4.66718 3.6377 8.18164V14.2422L2.72852 15.4541H17.2744L16.3652 14.2422V8.18164C16.3651 4.66728 13.5163 1.81852 10.002 1.81836Z" fill="white"/>
    </svg>
);

export default Svg;
